import React, { Component } from 'react'

export class Cupon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    }
  }

  render() {
    return (
        <div id="cupon">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
            <a href="files/cupon.pdf">
            <div id="where" style={{
                height: '20em',
                width: '100%',
                display: "flex",
                flexDirection: "column",
                justifyContent: 'center',
                alignItems:"center",
                alignContent: "center",
                // backgroundColor:"#f0f0f0"
                background: "url(img/cupon_fondo.png) center center no-repeat",
                backgroundColor:"#f0f0f0",
                //border: "1px solid black"
            }}>
              <h2 style={{}}>{this.props.data ? this.props.data.title : "loading"} </h2>
            
              <h4> {this.props.data ? this.props.data.click : "loading"}</h4>
      </div>
        </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Cupon
